import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function ProjectCoshhDestroyModal({
  currentCoshhDocument,
  onClose,
  onDelete,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectCoshh.components.ProjectCoshhDestroyModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={onDelete}>
            {i18nTShared('delete')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={onClose}
      usingSlimDimensions={true}
      usingStandardDimensions={false}
    >
      <div className='modalbox-body tw-p-8'>
        <h2 className='modalbox-header__sub-title tw-pb-4 tw-font-inter tw-text-l tw-font-semibold tw-tracking-auto tw-text-grey-900'>
          {i18nTShared('areYouSureYouWantToDelete', {
            interpolation: { escapeValue: false },
            name: currentCoshhDocument.title,
          })}
        </h2>
        <div>{i18nT('description')}</div>
      </div>
    </ModalBox>
  );
}

ProjectCoshhDestroyModal.propTypes = {
  currentCoshhDocument: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
